/**
 * @fileoverview i18n keys and country-code widths for additional contact fields.
 */

export const CONTACT_INFORMATION_I18N = {
  countryCodePlaceholder:
    "components.contactInformation.countryCodeSelectorPlaceholder",
  showInProfile: "components.contactInformation.showInProfile",
};

export const COUNTRY_CODE_SELECTOR_WIDTH = {
  tablet: "85%",
  desktop: "115%",
};

export const CONTACTS_LIMIT_MESSAGE_KEY =
  "components.contactsData.contactsLimitMessage";
